import { render, staticRenderFns } from "./deleteCouponPropertyPool.vue?vue&type=template&id=40cc37e2"
import script from "./deleteCouponPropertyPool.vue?vue&type=script&lang=js"
export * from "./deleteCouponPropertyPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports